import { Button, Label, RadioGroup } from "@/components/ui";
import {
  FileInput,
  FileUploader,
  FileUploaderContent,
  FileUploaderItem,
} from "@/components/ui/FileUpload";
import { useState } from "react";
import { useUploadOrderRequisition } from "../../network/useUploadOrderRequisition";

export const UploadOrderRequisition = ({
  patientId,
  requestGroupId,
  serviceRequestId,
}: {
  patientId: string;
  requestGroupId: string;
  serviceRequestId: string;
}) => {
  const [file, setFile] = useState<File[]>([]);
  const [entireOrder, setEntireOrder] = useState<boolean | undefined>(
    undefined,
  );

  const {
    mutate: uploadOrderRequisition,
    isPending: isUploadingOrderRequisition,
  } = useUploadOrderRequisition({
    patientId,
    requestGroupId,
    serviceRequestId,
  });

  const handleSubmit = () => {
    uploadOrderRequisition({
      file: file[0],
      entireOrder: entireOrder === true,
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <Label>Order Requisition File</Label>
      <FileUploader
        value={file}
        onValueChange={(files) => setFile(files ?? [])}
        dropzoneOptions={{
          accept: {
            "application/pdf": [".pdf"],
          },
          maxFiles: 1,
          multiple: false,
        }}
      >
        {file.length === 0 && (
          <FileInput className="border border-dashed border-link pl-2">
            <Button variant="link">Click or Drop Order Requisition PDF</Button>
          </FileInput>
        )}
        {file.length > 0 && (
          <FileUploaderContent>
            <FileUploaderItem index={0}>{file[0]?.name}</FileUploaderItem>
          </FileUploaderContent>
        )}
      </FileUploader>

      <Label>Were all tests added to the same order in Quanum?</Label>
      <RadioGroup
        id={`${serviceRequestId}-entire-order-radio`}
        onValueChange={(value) => setEntireOrder(value === "true")}
        defaultValue={undefined}
        options={[
          { label: "Yes", value: "true" },
          { label: "No", value: "false" },
        ]}
      />

      <Button
        variant="primary"
        size="xs"
        className="w-fit"
        onClick={handleSubmit}
        disabled={
          isUploadingOrderRequisition ||
          !file.length ||
          entireOrder === undefined
        }
      >
        Upload
      </Button>
    </div>
  );
};
